// Main-thread thumbnail generation. Decodes an image via
// createImageBitmap, resizes + center-crops to 256x256 on an
// OffscreenCanvas, and encodes to WebP.

const SUPPORTED = /^image\/(jpeg|jpg|png|webp|gif|avif)$/i;
const SIZE = 256;

export function canThumbnail(mime: string | undefined): boolean {
  return !!mime && SUPPORTED.test(mime);
}

export async function makeThumbnail(file: File): Promise<Uint8Array | null> {
  if (!canThumbnail(file.type)) return null;
  try {
    const bitmap = await createImageBitmap(file);
    try {
      const canvas = new OffscreenCanvas(SIZE, SIZE);
      const ctx = canvas.getContext("2d");
      if (!ctx) return null;

      const side = Math.min(bitmap.width, bitmap.height);
      const sx = (bitmap.width - side) / 2;
      const sy = (bitmap.height - side) / 2;
      ctx.drawImage(bitmap, sx, sy, side, side, 0, 0, SIZE, SIZE);

      const blob = await canvas.convertToBlob({
        type: "image/webp",
        quality: 0.7,
      });
      const buf = await blob.arrayBuffer();
      return new Uint8Array(buf);
    } finally {
      bitmap.close();
    }
  } catch {
    return null;
  }
}
